
import moment from "moment";
import { ComponentState, useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { InboxRequestObj, MessageItem } from "../../../../../dataModel/messagesModal";
import { getMessagesList } from "../../../../../redux/actions";
import { MetaData } from "../../../../../dataModel/documentModels";
import { MessageItemComponent } from "./messageItem";



export const TrashMessages = () => {

    const state: ComponentState = useSelector(states => {
        return states;
    });

    const { loadingState, messagesList } = state['MessagesReducer'];

    const emptyObj: InboxRequestObj = {
        inbox: false,
        sent: false,
        trash: true,
        currentPage: 1,
        pageSize: 10
    }
    const [requestObj, setRequestObj] = useState<InboxRequestObj>(emptyObj)
    const dispatch = useDispatch()
    const [isDataFetched, setIsDataFetched] = useState(false)
    const [messageList, setMessageList] = useState<MessageItem[]>()
    const [metaObj, setMetaObj] = useState<MetaData>()


    useEffect(() => {
        if (messagesList && messagesList.resultData) {
            setMessageList(messagesList.resultData)
            setMetaObj(messagesList.metaData)
        }
    }, [messagesList])


    // useEffect(() => {
    //     if (saveSignedDocResp && saveSignedDocResp.status) {
    //         dispatch(saveSignedDocResponse())
    //         setRequestObj({ ...requestObj, pageNumber: 1 })
    //         dispatch(getPendingDoc({ ...requestObj, pageNumber: 1 }))
    //     }
    // }, [saveSignedDocResp])




    useEffect(() => {
        if (!isDataFetched) {
            setIsDataFetched(true)
            dispatch(getMessagesList(requestObj))
        }
    }, [loadingState])



    function handleChangePage(event: any, newpage: any) {
        setRequestObj({ ...requestObj, currentPage: (newpage + 1) })
        dispatch(getMessagesList({ ...requestObj, currentPage: (newpage + 1) }))
    }

    function handleChangeRowsPerPage(event: any) {
        setRequestObj({ ...requestObj, pageSize: parseInt(event.target.value, 10), currentPage: 1 })
        dispatch(getMessagesList({ ...requestObj, pageSize: parseInt(event.target.value, 10), currentPage: 1 }))
    }

    const onHandleDeletedMessage = (message: MessageItem) => {
        let updatedMessageList = messageList?.filter( function (messageData) {
            return messageData.id !== message.id
          });
        setMessageList(updatedMessageList)
    }

    return (
        <MessageItemComponent
            tabSelectionID="tabs-3"
            tabId={2}
            loadingState={loadingState}
            messageList={messageList ? messageList : []}
            handleChangePage={handleChangePage}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            metaObj={metaObj}
            requestObj={requestObj}
            handleDeletedMessage={onHandleDeletedMessage}
            updateListViewMessageStatus={()=>{}}

        ></MessageItemComponent>
    );
}